// Helpers para Meta Pixel <> Conversions API.
// Devuelve las cookies _fbc y _fbp que instala el Pixel del navegador,
// además de un event_id que sirve para deduplicar eventos entre navegador y servidor.

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

export function getFbCookies() {
  return {
    fbc: readCookie("_fbc"),
    fbp: readCookie("_fbp"),
  };
}

export function newEventId() {
  // uuid-like corto. Suficiente para deduplicación por evento.
  return (
    Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10)
  );
}

/**
 * Dispara un evento en el Pixel del navegador (si existe) y devuelve el event_id
 * para que la llamada server-side use el mismo y Meta deduplique.
 */
export function trackPixelEvent(eventName, params = {}) {
  const eventId = newEventId();
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params, { eventID: eventId });
    }
    // También al dataLayer para GTM
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "meta_" + eventName.toLowerCase(),
        event_id: eventId,
        ...params,
      });
    }
  } catch (e) {
    // silencio: nunca debe romper la UX
  }
  return eventId;
}
